import clsx from 'clsx';
import Timer from './Timer';
import { CloseRounded as Close } from '../../components/icons';
import styles from './question.module.css';

type props = {
  isMobile?: boolean;
  question?: string;
  currentTimeSeconds?: number;
  setHideQuestion: React.Dispatch<React.SetStateAction<boolean>>;
};

const Header = ({
  isMobile,
  question,
  currentTimeSeconds,
  setHideQuestion,
}: props) => {
  const mobile = isMobile ? 'Mobile' : '';
  return (
    <div className={clsx(styles['headerWrapper' + mobile])}>
      <p className={clsx(styles.headerTitle)}>{`${question}`}</p>
      <div className={clsx(styles.headerRightWrapper)}>
        <div
          className={clsx(styles.headerCloseButton)}
          onClick={() => {
            setHideQuestion(true);
          }}
        >
          <Close />
        </div>
        <Timer currentTimeSeconds={currentTimeSeconds} />
      </div>
    </div>
  );
};

export default Header;
